import Header from '../../components/Header'
import CasaGiacomo from '../../components/identidades/CasaGiacomo';

function CasaGiacomoPage() {
    window.scrollTo(0, 0);
    return (
        <div>
            <Header isComunicacao={true}></Header>
            <CasaGiacomo></CasaGiacomo>
        </div>
    )
}

export default CasaGiacomoPage;